<div class="modal-header " >
	<div>
		<h5 class="modal-title mb-0">Calendario anual · Periodos</h5>
	</div>

	<button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body pt-0">

	<div class="row g-3">
		<!-- Sidebar: periodos -->
		<div class="col-12 col-xl-2">
			<div class=" p-3 h-100">
				<div class="d-flex align-items-center justify-content-between mb-2">
					<div>
						<div class="fw-semibold">Periodos</div>
					</div>
				</div>

				<!-- Lista de periodos -->
				<div class="d-flex flex-column gap-2">
					<ng-container *ngFor="let period of holidayData; let i = index">
						<button
            *ngIf="period.enable"
							type="button"
							class="btn text-start rounded-3 p-3 text-white"
							(click)="selectPeriod(i)"
							[ngClass]="i === 0 ? 'btn-primary' : i === 1 ? 'btn-success' : i === 2 ? 'btn-danger' : 'btn-secondary'"
							[style.transition]="'transform 140ms ease, box-shadow 140ms ease, border-color 140ms ease'"
							[style.transform]="i === selectedIndex ? 'translateX(6px)' : 'translateX(0)'"
							[style.outline]="i === selectedIndex ? '3px solid #3498db' : 'none'"
							[style.outlineOffset]="i === selectedIndex ? '2px' : null"
							[class.shadow-lg]="i === selectedIndex"
							[class.border]="i === selectedIndex"
							[class.border-3]="i === selectedIndex"
							[attr.aria-pressed]="i === selectedIndex"
						>
							<div class="d-flex align-items-center justify-content-between">
								<div>
									<div class="fw-semibold">Periodo {{ i + 1 }}</div>
									<small class="opacity-75">
										{{ period.startDay }}/{{ period.startMonth }} · {{ period.startHourStr }}
										→
										{{ period.endDay }}/{{ period.endMonth }} · {{ period.endHourStr }}
									</small>
								</div>
							</div>
						</button>

						<!-- Editor de horas (solo para el periodo seleccionado) -->
						<div *ngIf="i === selectedIndex" class="border rounded-3 p-2">
							<div class="mb-2">
								<label class="form-label mb-1">Hora inicio</label>
								<input
									type="time"
									class="form-control form-control-sm"
									[(ngModel)]="period.startHourStr"
									name="startHour{{ i }}"
									id="startHour{{ i }}"
								/>
							</div>
							<div>
								<label class="form-label mb-1">Hora fin</label>
								<input
									type="time"
									class="form-control form-control-sm"
									[(ngModel)]="period.endHourStr"
									name="endHour{{ i }}"
									id="endHour{{ i }}"
								/>
							</div>
						</div>
					</ng-container>
				</div>

			</div>
		</div>

		<!-- Main: calendario anual  -->
		<div class="col-12 col-xl-10">
			<div class="p-3">
				<div class="d-flex align-items-center justify-content-between mb-2">
					<div>
						<div class="fw-semibold">Calendario</div>
						<!-- <div class="small text-muted" *ngIf="selectedIndex !== null">
							Editando periodo {{ selectedIndex + 1 }} · click para <span class="fw-semibold">{{ editStage === 'start' ? 'inicio' : 'fin' }}</span>
						</div> -->
					</div>
				</div>

				<!-- Un solo datepicker mostrando 12 meses. El layout (3 por fila) se controla por CSS -->
				<div class="annual-datepicker " >
					<ng-template #t let-date let-focused="focused">
						<span [ngClass]="getDayClasses(date)">
							{{ date.day }}
						</span>
					</ng-template>

					<ngb-datepicker
						[startDate]="{ year: year, month: 1 }"
						[displayMonths]="12"
						[navigation]="'none'"
						[outsideDays]="'hidden'"
						[dayTemplate]="t"
						(dateSelect)="onCalendarSelect($event)"
					></ngb-datepicker>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="modal-footer">
	<button type="button" class="btn btn-primary" (click)="close()">
		{{ 'close' | translate }}
	</button>
</div>
